// S3 上传 action URL
export const UPLOAD_ACTION = {
    PRIVATE: '/api/sqm/shepherd/mall/sqm/common/service/S3Service/uploadFileForPrivateBucket',
    PUBLIC: '/api/sqm/shepherd/mall/sqm/common/service/S3Service/uploadFileForPublicBucket',
};
